import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { RootLayout } from '../root/root.component';
import { AuthService } from '../../../_services/auth.service'
import { pagesToggleService } from '../../services/toggler.service';
import { DxSelectBoxComponent } from 'devextreme-angular';
import * as moment from 'moment-timezone';

@Component({
  selector: 'condensed-layout',
  templateUrl: './condensed.component.html',
  styleUrls: ['./condensed.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class CondensedComponent extends RootLayout implements OnInit {
  customers = [];
  userData = {};
 // currentCompany = {};
  currentCompany={_id:"",UserName:"",currentCompany:""};
  todayDate = moment().locale('es').format('dddd D [de] MMMM [de] YYYY');

  constructor(
    toggler: pagesToggleService, router: Router, private authService: AuthService
  ) {
    super(toggler, router);

    // this.userData = this.authService.getUserData();
    // this.currentCompany = this.authService.getCurrentCompany();
  }
  menuLinks = [
    {
      label: 'Inicio',
      routerLink: '../console',
      iconType: 'pg',
      iconName: 'home'
    },
    {
      label: 'Smartreader',
      routerLink: '../smartreader',
      iconType: 'letter',
      iconName: 'sr'
    }


    // {
    //   label: 'Bodega',
    //   iconType: 'fa',
    //   iconName: 'fas fa-boxes',
    //   toggle: 'open',
    //   submenu: [
    //     {
    //       label: 'Dashboard',
    //       routerLink: '../wms/dashboard',
    //       iconType: 'fa',
    //       iconName: 'fas fa-chart-pie'
    //     },
    //     {
    //       label: 'Inventario',
    //       routerLink: '../wms/inventario',
    //       iconType: 'letter',
    //       iconName: 'in'
    //     },

    //     {
    //       label: 'Reportes',
    //       routerLink: '../wms/reportes-entrada',
    //       iconType: 'fa',
    //       iconName: 'fas fa-file-alt'
    //     },
    //     {
    //       label: 'Analíticas',
    //       routerLink: '../wms/analiticas',
    //       iconType: 'fa',
    //       iconName: 'fas fa-file-alt'
    //     }
    //   ]
    // },
    // {
    //   label: 'Trafico',
    //   iconType: 'fa',
    //   iconName: 'fas fa-boxes',
    //   toggle: 'open',
    //   submenu: [
    //     {
    //       label: 'Facturas',
    //       routerLink: '../inventory',
    //       iconType: 'letter',
    //       iconName: 'in'
    //     },
    //     {
    //       label: 'Inbond',
    //       routerLink: 'layouts/secondary',
    //       iconType: 'letter',
    //       iconName: 'ib'
    //     },
    //     {
    //       label: 'Despacho',
    //       routerLink: 'layouts/boxed',
    //       iconType: 'letter',
    //       iconName: 'dp'
    //     }
    //   ]
    // },
    // {
    //   label: 'Facturación',
    //   iconType: 'fa',
    //   iconName: 'fas fa-boxes',
    //   toggle: 'open',
    //   submenu: [
    //     {
    //       label: 'Tracking',
    //       routerLink: '../tracking/tracking',
    //       iconType: 'letter',
    //       iconName: 'in'
    //     }
    //   ]
    // }

  ];


  logout() {
    this.authService.logoutUser();
  }


  setcurrentCompany(selcurrentCompany: DxSelectBoxComponent) {

    if (selcurrentCompany.instance.option('selectedItem')) {
      console.log(selcurrentCompany.instance.option('selectedItem'));
      this.currentCompany = selcurrentCompany.instance.option('selectedItem');
      this.authService.setCurrentCompany(selcurrentCompany.instance.option('selectedItem'));
      //this.router.navigate(["console"]);
      // this.router.routeReuseStrategy.shouldReuseRoute = function () {
      //   return false;
      // };

    } else {
      // this.hasFormErrors = true;
      // this.errorMessage= "Select a valid status. "
    }



  }

  getCustomers() {
    console.log('buscar customeres')
    this.customers = this.authService.getCustomers();
    console.log(this.customers);

  }

  ngOnInit() {
    console.log('on init')
    this.getCustomers();

  }

}
